import React, { useCallback, useState } from 'react'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { Form, FormGroup, Label, ModalBody } from 'reactstrap'
import ErrorBoundary from '@/components/ErrorBoundary'
import { Input } from '@/components/inputs'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import { useDebouncedEffect } from '@/hooks/useDebouncedEffect'

const EditConstantCategoryDialog = React.memo(function EditConstantCategoryDialog ({ item, onAction, ...props }) {
  const [name, setName] = useState(item.name)
  const [latinName, setLatinName] = useState(item.latinName)
  const [serverErrors, setServerErrors] = useState({})

  const id = item.id ? item.id : 0
  const onNameChange = useCallback(x => setName(x.target.value), [])
  const onLatinNameChange = useCallback(x => setLatinName(x.target.value), [])
  const onActionButton = useCallback(() => onAction({ id, name, latinName }), [onAction, name, latinName, id])

  const { localize } = useLocalization()

  useDebouncedEffect(() => {
    if (name || latinName) {
      context.api.reportConstantService.validateCategory({ id, name, latinName })
        .then(() => setServerErrors({}))
        .catch(r => {
          const error = r ? r.response ? r.response.data ? r.response.data.error : null : null : null

          setServerErrors(error)
        })
    }
  }, [name, latinName, id], 300)

  return (
    <React.Fragment>
      <ValidationBoundary serverError={serverErrors}>
        <BasicHeader title='Common.AddConstantGroup' {...props} />
        <ModalBody>
          <ErrorBoundary>
            <Form>
              <FormGroup>
                <Label>{localize('Common.Name')}</Label>
                <Validator name='name' value={name} required>
                  <Input defaultValue={name} onChange={onNameChange} />
                </Validator>
              </FormGroup>
              <FormGroup>
                <Label>{localize('Common.LatinName')}</Label>
                <Validator name='latinName' value={latinName} required>
                  <Input defaultValue={latinName} onChange={onLatinNameChange} />
                </Validator>
              </FormGroup>
            </Form>
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid, isServerValid }) =>
          <ConfirmFooter onAction={onActionButton} disabled={!isValid || !isServerValid} icon='save' {...props} />}
        />
      </ValidationBoundary>
    </React.Fragment>)
})

export default {
  component: EditConstantCategoryDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/editConstantCategory.js